import { combineReducers } from '@ngrx/store';
import * as fromAddedValues from './added-values.reducer';
import * as fromContracts from './contracts.reducer';
import * as fromProducts from './products.reducer';
import * as fromRmsSpecifications from './rms-specification-form.reducer';
import * as fromSlots from './slots.reducer';
import * as fromRmsModifyFlag from './rms-modify-flag.reducer';
import * as fromOrderAvailability from './order-availability.reducer';
import * as fromCutOffState from './cut-off.reducer';
import * as fromCutOffTemperatureOffState from './cut-off-temperature.reducer';
import * as fromSingleCatalogsState from './single-catalogs.reducer';
import * as fromProductsOpenPlatform from './products.op.reducer';
import * as fromAddedValuesOpenPlatform from './added-values.op.reducer';
import * as fromContractsBalancesOpenPlatform from './contracts-balances.op.reducer';
import * as fromPaymentTermsOpenPlatform from './payment-terms.op.reducer';
import * as productsOpenPlatform from './open-platform/products.reducer';
import * as contractsOpenPlatform from './open-platform/contracts.reducer';
import * as combinationsOpenPlatform from './open-platform/combinations.reducer';
import * as addedValuesOpenPlatform from './open-platform/added-values.reducer';
import * as fromSlotsOpenPlatform from './open-platform/slots.reducer';
import * as fromFormsSnapshotsOpenPlatform from './open-platform/forms-snapshots.reducer';
import * as fromPumpPrimerMix from '@ordersnproducts/modules/shared/modules/pump-primer/redux/pump-primer.reducer';

export interface RmsSpecificationState {
  rmsSpecificationFormState: fromRmsSpecifications.RmsSpecificationFormState;
  productsLegacyState: fromProducts.ProductsState;
  productsOpenPlatformState: productsOpenPlatform.ProductsState;
  combinationsOpenPlatformState: combinationsOpenPlatform.State;
  contractsLegacyState: fromContracts.ContractState;
  contractsOpenPlatformState: contractsOpenPlatform.ContractState;
  addedValuesLegacyState: fromAddedValues.AddedValuesState;
  addedValuesOpenPlatformState: addedValuesOpenPlatform.AddedValuesState;
  slotsLegacyState: fromSlots.SlotsState;
  slotsOpenPlatformState: fromSlotsOpenPlatform.State;
  formsSnapshotsOpenPlatformState: fromFormsSnapshotsOpenPlatform.State;
  rmsModifyFlag: fromRmsModifyFlag.RmsModifyState;
  orderAvailabilityState: fromOrderAvailability.OrderAvailabilityState;
  cutOffState: fromCutOffState.CutOffState;
  cutOffTemperatureState: fromCutOffTemperatureOffState.CutOffTemperatureState;
  singleCatalogsState: fromSingleCatalogsState.SingleCatalogsState;
  ProductsOpenPlatform: fromProductsOpenPlatform.State;
  AddedValuesOpenPlatform: fromAddedValuesOpenPlatform.State;
  ContractBalancesOpenPlatform: fromContractsBalancesOpenPlatform.State;
  PaymentTermsOpenPlatform: fromPaymentTermsOpenPlatform.State;
  PumpPrimerMixState: fromPumpPrimerMix.IPumpPrimerState;
}

export const reducers = combineReducers({
  rmsSpecificationFormState: fromRmsSpecifications.rmsSpecificationFormReducer,
  productsLegacyState: fromProducts.productsReducer,
  productsOpenPlatformState: productsOpenPlatform.productsReducer,
  combinationsOpenPlatformState: combinationsOpenPlatform.reducer,
  contractsLegacyState: fromContracts.contractsReducer,
  contractsOpenPlatformState: contractsOpenPlatform.contractsReducer,
  addedValuesLegacyState: fromAddedValues.addedValuesReducer,
  addedValuesOpenPlatformState: addedValuesOpenPlatform.addedValuesReducer,
  slotsLegacyState: fromSlots.reducer,
  slotsOpenPlatformState: fromSlotsOpenPlatform.reducer,
  formsSnapshotsOpenPlatformState: fromFormsSnapshotsOpenPlatform.reducer,
  rmsModifyFlag: fromRmsModifyFlag.reducer,
  orderAvailabilityState: fromOrderAvailability.reducer,
  cutOffState: fromCutOffState.cutOffReducer,
  cutOffTemperatureState: fromCutOffTemperatureOffState.cutOffReducer,
  singleCatalogsState: fromSingleCatalogsState.reducer,
  ProductsOpenPlatform: fromProductsOpenPlatform.reducer,
  ContractBalancesOpenPlatform: fromContractsBalancesOpenPlatform.reducer,
  AddedValuesOpenPlatform: fromAddedValuesOpenPlatform.reducer,
  PaymentTermsOpenPlatform: fromPaymentTermsOpenPlatform.reducer,
  PumpPrimerMixState: fromPumpPrimerMix.pumpPrimerReducer,
});
